import React, {useEffect} from "react";
import SwaggerUI from 'swagger-ui'
import "swagger-ui/dist/swagger-ui.css";

export default function ApiDocs() {

  useEffect(() => {
    SwaggerUI({
      dom_id: '#apidocs',
      url:"/api/docs/index.json",
      docExpansion: "list"
    })
  }, [])

  return (
    <div id="apidocs">
    </div>
  );
}
